export default __webpack_public_path__ + "static/media/안주5.e17bde17.png";